// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._0BPHPtMtA0ejjvfaDpw{justify-content:center;align-items:center;display:flex}._0BPHPtMtA0ejjvfaDpw .zzys0vm4GE8lHjmp76GJ{align-items:center;gap:8px;width:100%;max-width:760px;padding-left:30px;padding-right:30px;display:flex}._0BPHPtMtA0ejjvfaDpw .zzys0vm4GE8lHjmp76GJ .Gtr0Ifk51mQMQCylfrkn:hover{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_0BPHPtMtA0ejjvfaDpw`,
	"content": `zzys0vm4GE8lHjmp76GJ`,
	"visibleName": `Gtr0Ifk51mQMQCylfrkn`
};
export default ___CSS_LOADER_EXPORT___;
